"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungList = exports.LeitungBomBehavior = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const ArticleList_1 = require("../ArticleList");
const ArticleUtils_1 = require("../ArticleUtils");
const Leitung_1 = require("./Leitung");
/**
 * Possible Behavior states of a LeitungList
 */
var LeitungBomBehavior;
(function (LeitungBomBehavior) {
    LeitungBomBehavior["UseAll"] = "UseAll";
    LeitungBomBehavior["UsePlaced"] = "UsePlaced";
})(LeitungBomBehavior = exports.LeitungBomBehavior || (exports.LeitungBomBehavior = {}));
/**
 * The `LeitungList` manages a list of `Leitung`
 */
class LeitungList extends ArticleList_1.ArticleList {
    constructor() {
        super(...arguments);
        this.bomBehavior = LeitungBomBehavior.UseAll;
    }
    static fromScratch() {
        return new LeitungList();
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const list = new LeitungList();
        list.fromJson(json, cloneStrategy);
        return list;
    }
    static fromModel(model) {
        const list = new LeitungList();
        list.fromModel(model);
        return list;
    }
    static fromArray(arr) {
        const list = new LeitungList();
        list.fromArray(arr);
        return list;
    }
    /**
     * Filters all `Leitung` which can be layed by a given `Kette` regarding dimensions
     *
     * @returns A new LeitungList with all filtered `Leitung` objects
     */
    filterByKette(kette) {
        const list = new LeitungList();
        const items = this.items;
        let leitung;
        for (leitung of items) {
            const canLayLeitungResult = kette.canLayLeitung(leitung);
            if (canLayLeitungResult.biegeradius && canLayLeitungResult.aussendurchmesser) {
                if (kette.indexBiegeradiusRBR) {
                    if (canLayLeitungResult.rbr) {
                        list.add(leitung);
                    }
                }
                else {
                    list.add(leitung);
                }
            }
        }
        return list;
    }
    /**
     * Filters all `Leitung` which belong to the given category
     *
     * @returns A new LeitungList with all filtered `Leitung` objects
     */
    filterByCategory(category) {
        return LeitungList.fromArray(this.items.filter((l) => l.categories.includes(category)));
    }
    fromJson(json, cloneStrategy = 'deep') {
        const items = json.map((i) => Leitung_1.Leitung.fromJson(i, cloneStrategy));
        // @ts-ignore
        this.items = items;
        this.model = items.map((i) => i.toModel());
        this.emitChange();
    }
    fromModel(model) {
        const items = model.map((m) => Leitung_1.Leitung.fromModel(m));
        // @ts-ignore
        this.items = items;
        this.model = model;
        this.emitChange();
    }
    toJson() {
        return this.items.map((i) => i.toJson());
    }
    toModel() {
        return this.model;
    }
    clone() {
        const clone = LeitungList.fromArray(this.items.map((i) => i.clone()));
        clone.bomBehavior = this.bomBehavior;
        return clone;
    }
    /**
     * Groups equal articles together.
     *
     * @param options The grouping options.
     * @returns The article groups.
     */
    group(options) {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, options);
    }
    /**
     * Groups equal articles together ignoring properties for Innenaufteilung, perfomance-optimized.
     */
    groupIgnoringIAProperties() {
        // for some reason there is sometimes an empty string or undefined if the leitungsIndex is not set...
        const sameLeitungIdx = (li1, li2) => {
            // identical value?
            if (li1 === li2)
                return true;
            // both "empty" in whatever "form" .. undefined, null or ''
            if (!li1 && !li2)
                return true;
            return false;
        };
        return this.group({
            comparator: (l1, l2) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                // common properties for all kind of Leitungen
                if (l1.id !== l2.id ||
                    l1.artNrGenerated !== l2.artNrGenerated ||
                    !sameLeitungIdx(l1.leitungIndex, l2.leitungIndex) ||
                    l1.laengeUeberstandLock !== l2.laengeUeberstandLock ||
                    ((_a = l1.leitungslaenge) === null || _a === void 0 ? void 0 : _a.m) !== ((_b = l2.leitungslaenge) === null || _b === void 0 ? void 0 : _b.m) ||
                    l1.beschriftungText !== l2.beschriftungText ||
                    l1.beschriftungFixedEndText !== l2.beschriftungFixedEndText ||
                    ((_c = l1.ueberstandFestpunkt) === null || _c === void 0 ? void 0 : _c.m) !== ((_d = l2.ueberstandFestpunkt) === null || _d === void 0 ? void 0 : _d.m) ||
                    ((_e = l1.ueberstandMitnehmer) === null || _e === void 0 ? void 0 : _e.m) !== ((_f = l2.ueberstandMitnehmer) === null || _f === void 0 ? void 0 : _f.m) ||
                    l1.cfx !== l2.cfx ||
                    l1.leitungIndex !== l2.leitungIndex) {
                    return false;
                }
                // no more checks required if both Leitungen are known
                if (l1.artNrExists && l2.artNrExists) {
                    return true;
                }
                // additional checks for freie and invented Leitungen
                return (l1.isPlaceholder === l2.isPlaceholder &&
                    ((_g = l1.aussendurchmesser) === null || _g === void 0 ? void 0 : _g.mm) === ((_h = l2.aussendurchmesser) === null || _h === void 0 ? void 0 : _h.mm) &&
                    ((_j = l1.biegeradiusMin) === null || _j === void 0 ? void 0 : _j.mm) === ((_k = l2.biegeradiusMin) === null || _k === void 0 ? void 0 : _k.mm) &&
                    ((_l = l1.kupferzahl) === null || _l === void 0 ? void 0 : _l.kg_km) === ((_m = l2.kupferzahl) === null || _m === void 0 ? void 0 : _m.kg_km) &&
                    ((_o = l1.gewichtKgProKm) === null || _o === void 0 ? void 0 : _o.kg_km) === ((_p = l2.gewichtKgProKm) === null || _p === void 0 ? void 0 : _p.kg_km) &&
                    (0, echain_shared_ts_utils_1.deepEqual)(l1.bezeichnung, l2.bezeichnung));
            },
        });
    }
    /**
     * Sorts internal list of leitungen by iaIndex, moving placeholder leitungen to the end.
     *
     * @returns this.
     */
    sortByIAIndex() {
        this.items.sort((a, b) => {
            var _a, _b;
            if (a.isPlaceholder && !b.isPlaceholder)
                return 1;
            if (b.isPlaceholder && !a.isPlaceholder)
                return -1;
            return ((_a = a.getIAIndexAsNumber()) !== null && _a !== void 0 ? _a : 0) - ((_b = b.getIAIndexAsNumber()) !== null && _b !== void 0 ? _b : 0);
        });
        return this;
    }
    /**
     * Calculates the total weight of all items in the list
     *
     * @returns
     */
    getTotalWeightPerLength() {
        var _a, _b;
        let totalWeightPerLength = 0.0;
        for (const leitung of this.items) {
            totalWeightPerLength += (_b = (_a = leitung.gewichtKgProKm) === null || _a === void 0 ? void 0 : _a.kg_km) !== null && _b !== void 0 ? _b : 0;
        }
        return echain_shared_quantities_1.WeightPerLength.kg_km(parseFloat(totalWeightPerLength.toFixed(10)));
    }
    /**
     * Calculates the total surface area all items in the list
     *
     * @returns
     */
    getTotalSurfaceArea() {
        let totalSurfaceAarea = 0.0;
        for (const leitung of this.items) {
            if (leitung.aussendurchmesser && leitung.aussendurchmesser.mm) {
                totalSurfaceAarea += Math.PI * Math.pow(leitung.aussendurchmesser.mm / 2, 2);
            }
        }
        return echain_shared_quantities_1.Area.mm2(parseFloat(totalSurfaceAarea.toFixed(10)));
    }
    /**
     * Calculates the total surface area all bounding rects of all items in the list
     */
    getTotalBoundingRectArea() {
        let totalSurfaceArea = 0.0;
        for (const leitung of this.items) {
            if (leitung.aussendurchmesser && leitung.aussendurchmesser.mm) {
                totalSurfaceArea += leitung.aussendurchmesser.mm * leitung.aussendurchmesser.mm;
            }
        }
        return echain_shared_quantities_1.Area.mm2(totalSurfaceArea);
    }
    /**
     * Get the BiggestDurchmesser of all items in the list
     *
     * @returns
     */
    getBiggestDurchmesser() {
        let biggestDurchmesser = 0;
        for (const leitung of this.items) {
            if (leitung.aussendurchmesser && leitung.aussendurchmesser.mm) {
                if (biggestDurchmesser === 0) {
                    biggestDurchmesser = leitung.aussendurchmesser.mm;
                }
                if (leitung.aussendurchmesser.mm > biggestDurchmesser) {
                    biggestDurchmesser = leitung.aussendurchmesser.mm;
                }
            }
        }
        return echain_shared_quantities_1.Length.mm(parseFloat(biggestDurchmesser.toFixed(10)));
    }
    /**
     * Get the SmallestBiegeradius of all items in the list
     */
    getSmallestBiegeradius() {
        let smallestBiegeradius;
        for (const leitung of this.items) {
            if (leitung.biegeradiusMin && leitung.biegeradiusMin.mm >= 0) {
                if (smallestBiegeradius === undefined) {
                    smallestBiegeradius = leitung.biegeradiusMin.mm;
                }
                if (leitung.biegeradiusMin.mm < smallestBiegeradius) {
                    smallestBiegeradius = leitung.biegeradiusMin.mm;
                }
            }
        }
        return echain_shared_ts_utils_1.NumberUtils.isDefinedNumber(smallestBiegeradius)
            ? echain_shared_quantities_1.Length.mm(parseFloat(smallestBiegeradius.toFixed(10)))
            : undefined;
    }
    /**
     * Get the BiggestMinBiegeradius of all items in the list
     */
    getBiggestMinBiegeradius() {
        let biggestMinBiegeradius;
        for (const leitung of this.items) {
            if (leitung.biegeradiusMin && leitung.biegeradiusMin.mm >= 0) {
                if (biggestMinBiegeradius === undefined) {
                    biggestMinBiegeradius = leitung.biegeradiusMin.mm;
                }
                if (leitung.biegeradiusMin.mm > biggestMinBiegeradius) {
                    biggestMinBiegeradius = leitung.biegeradiusMin.mm;
                }
            }
        }
        return biggestMinBiegeradius || biggestMinBiegeradius === 0
            ? echain_shared_quantities_1.Length.mm(parseFloat(biggestMinBiegeradius.toFixed(10)))
            : undefined;
    }
    /**
     * Get the SumOfAllDurchmesser of all items in the list
     *
     * @returns
     */
    getSumOfAllAussendurchmesser() {
        let sumOfAllAussendurchmesser;
        for (const leitung of this.items) {
            if (leitung.aussendurchmesser && leitung.aussendurchmesser.mm >= 0) {
                if (sumOfAllAussendurchmesser === undefined) {
                    sumOfAllAussendurchmesser = leitung.aussendurchmesser.mm;
                }
                else {
                    sumOfAllAussendurchmesser += leitung.aussendurchmesser.mm;
                }
            }
        }
        return sumOfAllAussendurchmesser || sumOfAllAussendurchmesser === 0
            ? echain_shared_quantities_1.Length.mm(parseFloat(sumOfAllAussendurchmesser.toFixed(10)))
            : undefined;
    }
    getUeberstandSummeMitnehmer() {
        let summeUeberstaendeMitnehmer = 0;
        this.toArray()
            .map((l) => (l.ueberstandMitnehmer ? l.ueberstandMitnehmer.m : 0))
            .forEach((l) => (summeUeberstaendeMitnehmer += l));
        return echain_shared_quantities_1.Length.m(summeUeberstaendeMitnehmer);
    }
    getUeberstandSummeFestpunkt() {
        let summeUeberstaendeFestpunkt = 0;
        this.toArray()
            .map((l) => (l.ueberstandFestpunkt ? l.ueberstandFestpunkt.m : 0))
            .forEach((l) => (summeUeberstaendeFestpunkt += l));
        return echain_shared_quantities_1.Length.m(summeUeberstaendeFestpunkt);
    }
    /**
     * Retrieves the cumulated weight of all leitungen in the list,
     * also considering ueberstandFestpunkt and ueberstandMitnehmer.
     */
    getCumulatedWeight() {
        return echain_shared_quantities_1.Weight.kg(this.items.reduce((cumulatedWeight, l) => cumulatedWeight +
            (l.gewichtKgProKm ? l.gewichtKgProKm.kg_m : 0) * (l.leitungslaenge ? l.leitungslaenge.m : 0), 0));
    }
    /**
     * Retrieves the cumulated weight per length of all leitungen in the list.
     */
    getCumulatedWeightPerLength() {
        return echain_shared_quantities_1.WeightPerLength.kg_km(this.items.reduce((cumulatedWeightPerLength, l) => cumulatedWeightPerLength + (l.gewichtKgProKm ? l.gewichtKgProKm.kg_km : 0), 0));
    }
    /**
     * Add missing IA indices for Leitungen and Placeholder Leitungen.
     * Order of existing Leitung and placeholder Leitung IA indices is preserved.
     */
    updateIaIndices(emit = true) {
        let index = 0;
        let placeholderIndex = 0;
        this.items
            .slice()
            .sort((l1, l2) => {
            const iaNumber1 = l1.getIAIndexAsNumber();
            const iaNumber2 = l2.getIAIndexAsNumber();
            if (!iaNumber1 || !iaNumber2) {
                if (!iaNumber1 && !iaNumber2) {
                    return 0;
                }
                else if (!iaNumber2) {
                    return -1;
                }
                else {
                    // !iaNumber1
                    return 1;
                }
            }
            return iaNumber1 - iaNumber2;
        })
            .forEach((l) => {
            if (l.isPlaceholder) {
                l.setIAIndexAsNumber(++placeholderIndex);
            }
            else {
                l.setIAIndexAsNumber(++index);
                // set iaIndex as default for beschriftungText
                if (l.beschriftung && l.beschriftung !== echain_shared_articles_1.LeitungBeschriftung.keine && l.beschriftungText == null) {
                    l.beschriftungText = l.iaIndex;
                }
                if (l.beschriftungFixedEnd &&
                    l.beschriftungFixedEnd !== echain_shared_articles_1.LeitungBeschriftung.keine &&
                    l.beschriftungFixedEndText == null) {
                    l.beschriftungFixedEndText = l.iaIndex;
                }
            }
        });
        if (emit) {
            this.emitChange();
        }
    }
    /**
     * Create new IA indices based on the order defined by the given Leitung array.
     *
     * @param leitungen the given Leitung array
     */
    updateIaIndicesByOrderArray(leitungen, emit = true) {
        let index = 0;
        let placeholderIndex = 0;
        this.removeAllIAIndices(false);
        leitungen.forEach((leitung) => {
            const matchedItem = this.items.find((item) => item.is(leitung));
            if (matchedItem) {
                if (matchedItem.isPlaceholder) {
                    matchedItem.setIAIndexAsNumber(++placeholderIndex);
                }
                else {
                    matchedItem.setIAIndexAsNumber(++index);
                }
            }
        });
        this.updateIaIndices(false);
        if (emit) {
            this.emitChange();
        }
    }
    removeAllIAIndices(emit = true) {
        for (const leitung of this.items) {
            leitung.setIAIndexAsNumber(undefined);
        }
        if (emit) {
            this.emitChange();
        }
    }
    /**
     * returns Leitunglist without placeholder
     */
    filterFreieLeitungenOut() {
        return this.filter((leitung) => !leitung.isPlaceholder);
    }
    filterByCategoryAndSubCategory(category, subCategory) {
        return this.toArray().filter((leitung) => {
            return leitung.subCategory === subCategory && leitung.categories.includes(category);
        });
    }
    toHerstellerLeitungen() {
        return this.toArray()
            .map((leitung) => {
            const name = leitung.manufacturer;
            const artNr = leitung.manufacturerPartNo;
            if (!name || !artNr)
                return undefined;
            return { name: leitung.manufacturer, artNr: leitung.manufacturerPartNo };
        })
            .filter((hl) => Boolean(hl));
    }
    getManufacturersByCategory(category) {
        return Array.from(new Set(this.toArray()
            .filter((leitung) => {
            return leitung.categories.includes(category);
        })
            .map((leitung) => leitung.manufacturer)
            .filter((m) => Boolean(m)))).sort();
    }
    getHerstellerLeitungenByCategoryAndManufacturer(category, manufacturer) {
        return this.toArray()
            .filter((leitung) => {
            return leitung.manufacturer === manufacturer && leitung.categories.includes(category);
        })
            .map((leitung) => {
            return { name: leitung.manufacturer, artNr: leitung.manufacturerPartNo };
        })
            .filter((hl) => Boolean(hl))
            .sort((a, b) => {
            return a.artNr.localeCompare(b.artNr);
        });
    }
    getUniqueManfuacturers() {
        if (!this.items.length)
            return [];
        return Array.from(new Set(this.items.map((l) => l.manufacturer).filter((m) => Boolean(m))));
    }
    filterLeitungenByCategoryAndHerstellerLeitung(category, herstellerLeitung) {
        return this.toArray().filter((leitung) => {
            return (leitung.manufacturer === herstellerLeitung.name &&
                leitung.manufacturerPartNo === herstellerLeitung.artNr &&
                leitung.categories.includes(category));
        });
    }
    /**
     * cumulates lengths of Leitungen with same artNr
     */
    getCumulatedLengthsByArtNr() {
        const cumulatedLeitungen = LeitungList.fromScratch();
        this.items.forEach((leitung) => {
            if (leitung.leitungslaenge) {
                const existingLeitung = cumulatedLeitungen.get(leitung.artNr, 'artNr');
                if (existingLeitung) {
                    if (!existingLeitung.leitungslaenge) {
                        throw new Error(`LeitungList.getCumulatedLengthsByArtNr: existingLeitung.leitungslaenge is undefined`);
                    }
                    existingLeitung.leitungslaenge = (0, echain_shared_quantities_1.Q)(echain_shared_quantities_1.Q.sum([existingLeitung.leitungslaenge.quantity, leitung.leitungslaenge.quantity], echain_shared_quantities_1.LengthUnits.mm));
                }
                else {
                    const newLeitung = Leitung_1.Leitung.fromScratch();
                    newLeitung.artNr = leitung.artNr;
                    newLeitung.leitungslaenge = leitung.leitungslaenge;
                    cumulatedLeitungen.add(newLeitung);
                }
            }
        });
        return cumulatedLeitungen;
    }
    /**
     * returns the total copper weight of all Leitungen in the list
     *
     * @returns
     */
    getCopperWeight() {
        const copperWeight = echain_shared_quantities_1.Weight.kg(0);
        this.items.forEach((leitung) => {
            if (leitung.leitungslaenge && leitung.kupferzahl)
                copperWeight.kg += leitung.leitungslaenge.m * leitung.kupferzahl.kg_m;
        });
        return copperWeight;
    }
    /**
     * Returns a new list with LeitungList filtered by set ArtNrCountry.
     */
    filterByArtNrCountry(artNrCountry) {
        return LeitungList.fromArray(this.items.filter((article) => article.localizedArtNr && article.localizedArtNr[artNrCountry]));
    }
    /**
     * Returns a new list filtered by min/max aussendurchmesser.
     */
    filterByAussendurchmesser({ min, max }) {
        if (min && max) {
            const min_mm = min.mm;
            const max_mm = max.mm;
            return LeitungList.fromArray(this.items.filter((leitung) => {
                var _a, _b;
                const d_mm = (_b = (_a = leitung.aussendurchmesser) === null || _a === void 0 ? void 0 : _a.mm) !== null && _b !== void 0 ? _b : 0;
                return d_mm >= min_mm && d_mm <= max_mm;
            }));
        }
        if (min) {
            const min_mm = min.mm;
            return LeitungList.fromArray(this.items.filter((leitung) => { var _a, _b; return ((_b = (_a = leitung.aussendurchmesser) === null || _a === void 0 ? void 0 : _a.mm) !== null && _b !== void 0 ? _b : 0) >= min_mm; }));
        }
        if (max) {
            const max_mm = max.mm;
            return LeitungList.fromArray(this.items.filter((leitung) => { var _a, _b; return ((_b = (_a = leitung.aussendurchmesser) === null || _a === void 0 ? void 0 : _a.mm) !== null && _b !== void 0 ? _b : 0) <= max_mm; }));
        }
        return LeitungList.fromArray(this.toArray());
    }
    /**
     * Returns a new list filtered by LeitungBomBehavior
     *
     * @param options
     * options.withPlaceholder to decide if List should have placeholders or no
     */
    filterForBom({ withPlaceholder }) {
        const bomItemsMap = {
            [LeitungBomBehavior.UseAll]: () => this.items,
            [LeitungBomBehavior.UsePlaced]: () => this.getPlacedLeitungArray(),
        };
        const bomList = LeitungList.fromArray(bomItemsMap[this.bomBehavior]());
        return withPlaceholder ? bomList : bomList.filterFreieLeitungenOut();
    }
    getPlacedLeitungList() {
        return LeitungList.fromArray(this.getPlacedLeitungArray());
    }
    getPlacedLeitungArray() {
        return this.items.filter((leitung) => leitung.isPlacedInKette());
    }
    getUnplacedLeitungList() {
        return LeitungList.fromArray(this.getUnplacedLeitungArray());
    }
    getUnplacedLeitungArray() {
        return this.items.filter((leitung) => !leitung.isPlacedInKette());
    }
    getSortedByLocalTransformXAsc() {
        return LeitungList.fromArray(this.getPlacedLeitungArray().sort((l1, l2) => l1.localTransformPosition.x > l2.localTransformPosition.x ? 1 : -1));
    }
    getSortedByLocalTransformXDesc() {
        return LeitungList.fromArray(this.getPlacedLeitungArray().sort((l1, l2) => l1.localTransformPosition.x <= l2.localTransformPosition.x ? 1 : -1));
    }
    hasReadycable() {
        return this.items.some((leitung) => leitung.isReadycable());
    }
}
exports.LeitungList = LeitungList;
LeitungList.groupingOptionsIgnoringIAProperties = {
    ignoreProperties: ['_iaIndex', 'localTransform'],
};
//# sourceMappingURL=LeitungList.js.map